const criterionWeightSuffix = /\s*\(weight:\s*[^)]*\)\s*$/i

export const getDisplayCriterionText = text =>
  typeof text === 'string' ? text.replace(criterionWeightSuffix, '').trim() : text
